<template>
  <div>
    <div class="custom-button-group">
      <template v-for="(customerType, index) in customerTypes">
        <b-button
            :key="customerType"
            :variant="value === customerType ? 'primary' : 'transparent'"
            :class="buttonClass(index)"
            style="border-radius: 4px"
            @click="onClick(customerType)"
        >
          {{ lodash.upperFirst($t(`customers.types.${customerType}`)) }}
        </b-button>
      </template>
    </div>
  </div>
</template>

<script>
// if item.values not present, then set item.values = [item.value]
export default {
  name: 'customer-type-button-group',
  props: {
    value: {type: String, default: 'processing'}
  },
  data() {
    return {
      customerTypes: ['processing', 'partner', 'farmer'],
    }
  },
  methods: {
    buttonClass(index) {
      return {
        'ms-1': index > 0,
        'me-1': index < this.customerTypes.length - 1,
      }
    },
    onClick(customerType) {
      this.$emit('input', customerType)
      this.$emit('click', customerType)
    }
  }
}
</script>

<style scoped>
::v-deep {
  .btn {
    padding: 8px 16px;
    font: 600 14px/16px Lato, sans-serif;
  }
}
.custom-button-group {
  background-color: #F2F4F7;
  border-radius: 8px;
  padding: 4px;
  width: fit-content;
}
</style>
